<template>
  <div>
    <a href="javascript:void(0);" @click="navToClientDashboard">
      <i class="material-icons-outlined align-middle">visibility</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    navToClientDashboard: function () {
      this.setClientUser();
      this.navTo("/home/client/client_dashboard", {
        id: this.params.data.company_id,
      });
    },
    setClientUser: function () {
      this.$store.commit("setViewingAs", {
        role: "client",
        id: this.params.data.company_id,
        name: this.params.data.company_name,
        email: this.params.data.email,
        photoURL: this.params.data.photo_url ? this.params.data.photo_url : "",
      });
    },
    navTo: function (url, query) {
      this.$router.push({
        path: url,
        query: query,
      });
    },
  },
};
</script>
